import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import { buildWhatsappUrl } from './contact';

const iconStyle = (Icon) => <Icon />;

export const footerSocialData = [
	{
		name: 'Instagram',
		icon: iconStyle(FaInstagram),
		href: 'https://www.instagram.com/radixagro/',
	},
	{
		name: 'Facebook',
		icon: iconStyle(FaFacebook),
		href: 'https://www.facebook.com/radixagro', // TODO: confirmar URL real de Facebook
	},
	{
		name: 'LinkedIn',
		icon: iconStyle(FaLinkedin),
		href: 'https://www.linkedin.com/company/radixagro', // TODO: confirmar URL real de LinkedIn
	},
	{
		name: 'WhatsApp',
		icon: iconStyle(FaWhatsapp),
		href: buildWhatsappUrl(),
	},
];

export const footerData = [
	{
		title: 'Contactos',
		links: '/signup',
	},
	{
		title: 'Productos',
		links: '/productos',
	},
	// {
	// 	title: 'Press',
	// 	links: ['Logos', 'Events', 'Stories', 'Office'],
	// },
	// {
	// 	title: 'Legal',
	// 	links: ['GDPR', 'Privacy Policy', 'Terms of Service', 'Disclaimer'],
	// },
];